var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('BarChart',{key:Date.now(),ref:"chart",attrs:{"datasets":_vm.datasets,"labels":_vm.labels,"legends":_vm.legends,"options":_vm.options},on:{"click:chart":_vm.onClickChart,"click:legend":_vm.onClickLegend}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }